import { Reveal, Overline } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Anniversary pricing. Ten seats. Then it's gone.",
    body: "We charge $25,000 to build your Amazon business for you. For our 10th year, we're teaching 10 people to do what we do — for $6,997, one-time. When the seats are claimed, the offer closes. No extensions.",
  },
  {
    n: "02",
    title: "Not a course. Not done-for-you.",
    body: "You own the business and you do the work — our operators sit beside you from entity setup through your first sales. Daily support, four live one-to-one checkpoints, and written playbooks for every stage.",
  },
  {
    n: "03",
    title: "Six months, with a real commitment.",
    body: "Complete every checkpoint. If you haven't reached $10,000 in gross Amazon sales in six months, we keep working with you at no additional cost until you do. That's a commitment to keep coaching — and we put it in writing.",
  },
];

export function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal>
          <Overline data-testid="manifesto-overline">The anniversary offer</Overline>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
            Why we are doing this once —{" "}
            <span className="text-ink/40">and never again.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-px bg-white/10 md:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12} className="bg-white">
              <article
                data-testid={`manifesto-chapter-${c.n}`}
                className="flex h-full flex-col p-8 md:p-12"
              >
                <span className="font-display text-7xl font-black tracking-tighter text-stroke md:text-8xl">
                  {c.n}
                </span>
                <h3 className="mt-8 font-display text-2xl font-bold tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-4 font-body text-sm leading-relaxed text-ink/60">
                  {c.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
